import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
})
export class CounterComponent implements OnInit {
  counter: number;
  currentValue: number;
  constructor(public globalService: GlobalService) {}

  ngOnInit() {
    this.globalService.takeAWhile().subscribe(($) => {
      this.counter = $;
      this.currentValue = (this.counter * 100) / 60;
    });
  }
}
